import { AuthRestfulService } from "./auth-restful.service";

class AuthApiService extends AuthRestfulService {
  //login
  public async doLogin(request: any): Promise<any> {
    const response = await this.doPost("/login", {
      user_name: request.roleName,
      password: request.password,
    });

    sessionStorage.setItem("user_id", response.user_id);
    sessionStorage.setItem("token", response.token);
    return response;
  }

  //me
  public async me(): Promise<any> {
    const userId = sessionStorage.getItem("user_id");
    const token = sessionStorage.getItem("token");

    const response = await this.doGet("/me", {
      user_id: userId,
      token: token,
    });
    return response;
  }
}

export const authApiService = new AuthApiService();
export default authApiService;
